import { Link } from 'react-router-dom';
import { FaInstagram, FaTelegram, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer className='pt-20 pb-8 relative overflow-hidden'>
            <div className='absolute inset-0 bg-gradient-to-br from-[#232323] via-[#1a1a1a] to-[#0f0f0f]'></div>

            <div className='absolute inset-0 bg-gradient-to-tr from-blue-500/5 via-transparent to-purple-500/5'></div>

            <div className='container mx-auto relative z-10'>
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16'>
                    <div>
                        <h3 className='text-2xl font-bold text-white mb-4 bg-gradient-to-r from-blue-500 to-pink-500 bg-clip-text text-transparent'>
                            MaxPhoto
                        </h3>
                        <p className='text-gray-400 text-sm leading-relaxed mb-6'>
                            Профессиональное фотооборудование и аксессуары для создания идеальных снимков.
                        </p>
                        <div className='flex gap-4'>
                            <a
                                href='https://www.instagram.com/maxphoto.uz/'
                                className='w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center text-white hover:scale-110 transition-transform duration-300'
                                aria-label="Instagram"
                            >
                                <FaInstagram size={18} />
                            </a>
                            <a
                                href='https://t.me/MaxPhotouz'
                                className='w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center text-white hover:scale-110 transition-transform duration-300'
                                aria-label="Telegram"
                            >
                                <FaTelegram size={18} />
                            </a>
                        </div>
                    </div>

                    <div>
                        <h4 className='text-white font-semibold text-lg mb-4'>Быстрые ссылки</h4>
                        <ul className='space-y-3'>
                            {['О нас', 'Контакты'].map((link, idx) => (
                                <li key={idx}>
                                    <Link to='/' className='text-gray-400 hover:text-orange-500 transition-colors text-sm flex items-center group'>
                                        <span className='w-0 h-0.5 bg-orange-500 group-hover:w-4 transition-all duration-300 mr-2'></span>
                                        {link}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className='text-white font-semibold text-lg mb-4'>Категории</h4>
                        <ul className='space-y-3'>
                            {['Камеры', 'Объективы', 'Штативы', 'Освещение', 'Аксессуары'].map((category, idx) => (
                                <li key={idx}>
                                    <Link to={`/search?query=${category}`} className='text-gray-400 hover:text-orange-500 transition-colors text-sm flex items-center group'>
                                        <span className='w-0 h-0.5 bg-orange-500 group-hover:w-4 transition-all duration-300 mr-2'></span>
                                        {category}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className='text-white font-semibold text-lg mb-4'>Контакты</h4>
                        <ul className='space-y-4'>
                            <li className='flex items-start gap-3 text-gray-400 text-sm'>
                                <FaPhone className='text-orange-500 mt-1 flex-shrink-0' />
                                <span>
                                    <a href="tel:+998909601201">
                                        +998 90 960 12 01
                                    </a>
                                </span>
                            </li>
                            <li className='flex items-start gap-3 text-gray-400 text-sm'>
                                <FaEnvelope className='text-orange-500 mt-1 flex-shrink-0' />
                                <span>info@max-photo.uz</span>
                            </li>
                            <li className='flex items-start gap-3 text-gray-400 text-sm'>
                                <FaMapMarkerAlt className='text-orange-500 mt-1 flex-shrink-0' />
                                <span>Ташкент, Узбекистан</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className='pt-8 border-t border-white/10'>
                    <div className='flex flex-col md:flex-row justify-between items-center gap-4'>
                        <div className='text-center md:text-left text-sm text-gray-500'>
                            Copyright &copy; MaxPhoto {year}. Все права защищены.
                        </div>
                        <div className='flex gap-6 text-xs text-gray-500'>
                            <a href='/' className='hover:text-orange-500 transition-colors'>Политика конфиденциальности</a>
                            <a href='/' className='hover:text-orange-500 transition-colors'>Условия использования</a>
                        </div>
                    </div>
                </div>
            </div>

            <div className='absolute bottom-0 left-0 w-64 h-64 bg-blue-500/5 rounded-full blur-3xl'></div>
            <div className='absolute top-0 right-0 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl'></div>
        </footer>
    );
};

export default Footer;